export const KEY = 'MINIMUM_ANAMORPHIC_CAPTURE_RESOLUTION';
export const LABEL = 'Minimum Anamorphic Capture Resolution';
